import { Injectable, Inject, Injector } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { AuthService } from '../auth/auth.service';
import { EventsManagerService } from '../common/events-manager.service';
import { ISmartenitConfig } from '../smartenit-config.interface';
import { DataQueryService } from '../common/data-query.service';
import { IRequestOptions } from '../common/request-options.interface';
import { DatabaseService } from '../storage/database.service';
import { PersistentCRUDService } from '../storage/persistent-crud.service';
import { SyncService } from '../storage/sync.service';
import { WebSocketsService } from '../websockets/websockets.service';
import { PluginFactoryService } from '../plugins/plugin-factory.service';
import { DeviceModel } from '../models/device.model';
import { HttpInterceptor } from '../common/http-interceptor.service';
import { AppConfigurationService } from '../common/app-configuration.service';
import { DeviceReferenceService } from '../common/device-reference.service';

@Injectable()
export class DevicesService extends PersistentCRUDService {
  private static _devices: any = {};

  constructor(
    http: HttpInterceptor,
    authService: AuthService,
    public dbService: DatabaseService,
    public webSocketsService: WebSocketsService,
    public pluginFactory: PluginFactoryService,
    syncService: SyncService,
    dataQueryService: DataQueryService,
    eventsService: EventsManagerService,
    AppConfiguration: AppConfigurationService,
    injector: Injector,
    public deviceReferenceService: DeviceReferenceService
  ) {
    super(
      'devices',
      http,
      authService,
      dbService,
      syncService,
      dataQueryService,
      eventsService,
      AppConfiguration,
      injector
    );
  }

  public discover(discoverOnlyNewDevices?: boolean, payload?: any): Observable<any> {
    if (!payload) {
      payload = {};
    }

    if (discoverOnlyNewDevices === true) {
      payload.onlyNewDevices = true;
    }

    return this.post('discover', payload).map((apiResponse) => {
      if (apiResponse && apiResponse.data && Array.isArray(apiResponse.data)) {
        for (let i = 0; i < apiResponse.data.length; i++) {
          apiResponse.data[i] = this.createModel(apiResponse.data[i]);
        }
      }

      return apiResponse;
    });
  }

  public link(deviceId: string): Observable<any> {
    return this.post('link', { deviceId });
  }

  public linkDevice(device: any): Observable<any> {
    return this.post('link', device);
  }

  public createModel(data: any): DeviceModel {
    if (
      data.hasOwnProperty('_id') &&
      DevicesService._devices.hasOwnProperty(data._id)
    ) {
      const memoryDevice: DeviceModel = DevicesService._devices[data._id];
      memoryDevice.data = data;

      memoryDevice.loadBasicInfo(memoryDevice, data);
      memoryDevice.loadPluginsAndProcessors(memoryDevice, data);

      DevicesService._devices[data._id] = memoryDevice;

      return DevicesService._devices[data._id];
    } else {
      const newDevice = new DeviceModel(
        data,
        this,
        this.dbService,
        this.webSocketsService,
        this.pluginFactory,
        this.deviceReferenceService
      );

      newDevice.data = data;

      DevicesService._devices[newDevice._id] = newDevice;
      return newDevice;
    }
  }

  public removeFromLocalStorage(
    resourceId: string,
    removeData: any
  ): Observable<any> {
    return super
      .removeFromLocalStorage(resourceId, removeData)
      .map((removeDataRes) => {
        const deviceToRemove: DeviceModel = DevicesService._devices[resourceId];
        if (deviceToRemove) {
          deviceToRemove.clearResources();
          delete DevicesService._devices[resourceId];
        }
        this.pluginFactory.removePluginsForDevice(resourceId);

        return removeDataRes;
      });
  }

  public clearDevices() {
    Object.keys(DevicesService._devices).forEach((key) => {
      DevicesService._devices[key].clearResources();
    });
    DevicesService._devices = {};
  }

  /**
   * Query the information for a device
   * @param model Device model
   */
  public getInfo(model?: string): Observable<any> {
    let data = null;

    if (model) {
      data = {
        q: JSON.stringify({ model })
      };
    }

    return this.get('info', data);
  }
}
